import * as _  from 'lodash';
class UniqueIDService  {
  
    getUniqueID(prefix) {
        return  _.uniqueId(new Date().getTime()) + "-" + Math.random(10000000) 
    }
    
}

export  const uniqueIDService=new UniqueIDService();